import { render, staticRenderFns } from "./CustomerNote.vue?vue&type=template&id=0788e7e4&scoped=true"
import script from "./CustomerNote.vue?vue&type=script&lang=js"
export * from "./CustomerNote.vue?vue&type=script&lang=js"
import style0 from "./CustomerNote.vue?vue&type=style&index=0&id=0788e7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788e7e4",
  null
  
)

export default component.exports